module.exports = __webpack_public_path__ + "img/science-fiction.dc4492d2.svg";